import { Component, Input } from '@angular/core'
import { AppPaths } from 'src/app/app-routing.module'
import { AppStateService } from 'src/app/core/services/app-state.service'
import { ProviderInfo } from 'src/app/obstacle/model/provider-info.model'
import { Layers } from 'src/app/shared/layers-config/layers'

@Component({
  selector: 'app-obstacle-segment-data',
  templateUrl: './obstacle-segment-data.component.html',
  standalone: false,
})
export class ObstacleSegmentComponent {
  public layerIds = Layers
  public isVAWarningLayerVisible: boolean | undefined
  public isBDVWarningVisible: boolean | undefined
  public isCSWarningVisible: boolean | undefined

  constructor(private appState: AppStateService) {
    const layers = this.appState.selectLayers()
    if (layers) {
      this.isVAWarningLayerVisible = layers?.some((layer) => layer === Layers.VAWarning.name)
      this.isBDVWarningVisible = layers?.some((layer) => layer === Layers.BDVWarning.name)
      this.isCSWarningVisible = layers?.some((layer) => layer === Layers.CSWarning.name)
    } else {
      this.isVAWarningLayerVisible = true
      this.isBDVWarningVisible = true
      this.isCSWarningVisible = false
    }
    this.updateQueryParameters()
  }

  toggleLayerVisbility(layerId: string) {
    switch (layerId) {
      case Layers.VAWarning.name:
        this.isVAWarningLayerVisible = !this.isVAWarningLayerVisible
        break
      case Layers.BDVWarning.name:
        this.isBDVWarningVisible = !this.isBDVWarningVisible
        break
      case Layers.CSWarning.name:
        this.isCSWarningVisible = !this.isCSWarningVisible
        break
      default:
        break
    }
    this.updateQueryParameters()
  }

  updateQueryParameters() {
    const layers = this.appState
      .selectLayers()
      .filter(
        (layer) =>
          !(layer == Layers.VAWarning.name) &&
          !(layer == Layers.BDVWarning.name) &&
          !(layer == Layers.CSWarning.name),
      )

    if (this.isVAWarningLayerVisible) {
      layers.push(Layers.VAWarning.name)
    }
    if (this.isBDVWarningVisible) {
      layers.push(Layers.BDVWarning.name)
    }
    if (this.isCSWarningVisible) {
      layers.push(Layers.CSWarning.name)
    }
    this.appState.setState(AppPaths.Obstacle, {
      layers: layers?.toString(),
    })
  }
}
